import {
  Tooltip as RadixTooltip,
  type TooltipProps as RadixTooltipProps
} from '@radix-ui/themes'
import { forwardRef } from 'react'

export const Tooltip = forwardRef<HTMLDivElement, RadixTooltipProps>(
  (props, ref) => {
    return <RadixTooltip ref={ref} {...props} />
  }
)

Tooltip.displayName = 'Tooltip'
